//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../Preferences/Preferences.SessionPreferences.js";
let d=[[[0,"BundleColor",1,0],[0,"CompAttributeTitle",1,0],[0,"CompListColHeading",1,0],[0,"ComponentListColumnTitle",1,0],[0,"ComponentMatchMethod",1,0],[0,"DefaultHarnessName",1,0],[0,"DeleteStockOnRoute",1,0],[0,"RouteLevelEnum",1,0],[0,"StockStyleEnum",1,0],[0,"WirePath",1,0],[0,"WireStock",1,0]],[[["numMethods"],"GetCompMatchMethodPriorityList",{R_:{priorityList:""}},0,0],[["priorityList"],"SetCompMatchMethodPriorityList",{},1,0]],[]];
SPLM.Preferences.WiringPreferences = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.WiringPreferences";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.WiringPreferences.CompMatchMethod = Object.freeze({
    "Attribute" : "Attribute", "ComponentName" : "ComponentName", "FileName" : "FileName"});

SPLM.Preferences.WiringPreferences.CompListColumnHeading = Object.freeze({
    "DeviceID" : "DeviceID", "ConnectorID" : "ConnectorID", "PartName" : "PartName", "Description" : "Description"});

SPLM.Preferences.WiringPreferences.RouteLevelGroupEnumOptions = Object.freeze({
    "PinLevel" : "PinLevel", "ComponentLevel" : "ComponentLevel"});

SPLM.Preferences.WiringPreferences.StockStyleGroupEnumOptions = Object.freeze({
    "Centerline" : "Centerline", "Simple" : "Simple"});

export default SPLM;